export const navigation = {
  categories: [
    {
      id: "clothing",
      name: "Clothing",
      sections: [
        {
          id: "shirts",
          name: "Shirts",
          items: [
            { name: "Plain", id: "plain_shirts" },
            { name: "Sanganeri", id: "sanganeri_shirts" },
            { name: "Checks", id: "checks_shirts" },
            {
              name: "Double Pocket",
              id: "double_pocket_shirts",
            },
            { name: "Hunting", id: "hunting_shirts" },
            { name: "View All", id: "shirts", viewAll: true },
          ],
        },
        {
          id: "trousers",
          name: "Trousers",
          items: [
            { name: "Chino", id: "chino_trousers" },
            { name: "Cotton", id: "cotton_trousers" },
            { name: "Formal", id: "formal_trousers" },
            { name: "Cargo", id: "cargo_trousers" },
            { name: "Joggers", id: "joggers_trousers" },
            { name: "View All", id: "trousers", viewAll: true },
          ],
        },
        {
          id: "jeans",
          name: "Jeans",
          items: [
            { name: "Ankle", id: "ankle_length_jeans" },
            { name: "Straight Fit", id: "straight_fit_jeans" },
            { name: "Bell Bottom", id: "bell_bottom_jeans" },
            { name: "View All", id: "jeans", viewAll: true },
          ],
        },
        {
          id: "t_shirts",
          name: "T-Shirts",
          items: [{ name: "Polo", id: "polo_t_shirts" }],
        },
      ],
    },
    {
      id: "wedding_collection",
      name: "Wedding Collection",
      sections: [
        {
          id: "shervani",
          name: "Shervani",
          items: [
            { name: "Plain Shervani", id: "plain_shervani" },
            { name: "Work Shervani", id: "work_shervani" },
            { name: "Hand Work Shervani", id: "hand_work_shervani" },
            { name: "Hand Work Angrakha", id: "hand_work_angrakha_shervani" },
            { name: "View All", id: "shervani", viewAll: true },
          ],
        },
        {
          id: "koti",
          name: "Koti",
          items: [
            { name: "Plain", id: "plain_koti" },
            { name: "Hunting", id: "hunting_koti" },
            { name: "Printed", id: "printed_koti" },
            { name: "Velvet", id: "velvet_koti" },
            { name: "View All", id: "koti", viewAll: true },
          ],
        },
        {
          id: "fabric",
          name: "Fabric",
          items: [
            { name: "Shirting", id: "shirting_fabric" },
            { name: "Shervani", id: "shervani_fabric" },
            { name: "Suit", id: "suit_fabric" },
            { name: "Kurta Pajama", id: "kurta_pajama_fabric" },
            { name: "View All", id: "fabric", viewAll: true },
          ],
        },
        {
          id: "ethenic",
          name: "Ethenic",
          items: [
            { name: "Jodhpuri Suit", id: "jodhpuri_suit_ethenic" },
            { name: "3 Piece Suit", id: "3_piece_suit_ethenic" },
            { name: "2 Piece Suit", id: "2_piece_suit_ethenic" },
            { name: "View All", id: "ethenic", viewAll: true },
          ],
        },
        {
          id: "safa",
          name: "Safa",
          items: [
            { name: "Pure", id: "pure_safa" },
            { name: "Cotton", id: "cotton_safa" },
            { name: "View All", id: "safa", viewAll: true },
          ],
        },
        {
          id: "achkan",
          name: "Achkan",
          items: [{ name: "Achkan", id: "achkan" }],
        },
        {
          id: "kurta_pajama",
          name: "Kurta Pajama",
          items: [{ name: "Kurta Pajama", id: "kurta_pajama" }],
        },
      ],
    },
    {
      id: "accessories",
      name: "Accessories",
      sections: [
        {
          id: "accessories",
          name: "Accessories",
          items: [
            { name: "Mod", id: "mod" },
            { name: "Kalangi", id: "kalangi" },
            { name: "Surface", id: "surface" },
            { name: "Mala", id: "mala" },
            { name: "Kantha Surface", id: "kanta_surface" },
            { name: "Shervani Belt", id: "shervani_belt" },
            { name: "Chandi Katari", id: "chandi_katari" },
            { name: "Peetal Katari", id: "peetal_katari" },
            { name: "Chandi Talwar", id: "chandi_talwar" },
            { name: "Jhalari", id: "jhalari" },
            { name: "Shervani Juti", id: "shervani_juti" },
            { name: "Katar Belt", id: "katar_belt" },
            { name: "View All", id: "accessories", viewAll: true },
          ],
        },
      ],
    },
  ],
  pages: [],
};
